
export default function Footer() {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-b from-[#0a1628] to-[#050a14] border-t border-white/10 py-16 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <img 
                src="https://static.readdy.ai/image/f493cbe5c2084134677121347fdba237/214be233785e39ebb6795040f74f7c21.png" 
                alt="Windie's Mania SHABADABA Logo" 
                className="w-12 h-12 object-contain"
              />
              <h4 className="text-xl font-bold text-[#ff1493]">
                Windie's Mania SHABADABA
              </h4>
            </div>
            <p className="text-white/60 leading-relaxed mb-6">
              インディーズカルチャーを届けるラジオ番組。<br />
              小劇団、インディーズ歌手、自主映画など、<br />
              マイナーだけど魅力的なコンテンツを紹介しています。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-[#ff1493] rounded-full transition-all duration-300 cursor-pointer">
                <i className="ri-twitter-x-line text-white"></i>
              </a>
              <a href="#" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-[#ff1493] rounded-full transition-all duration-300 cursor-pointer">
                <i className="ri-instagram-line text-white"></i>
              </a>
              <a href="#" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-[#ff1493] rounded-full transition-all duration-300 cursor-pointer">
                <i className="ri-youtube-line text-white"></i>
              </a>
              <a href="#" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-[#ff1493] rounded-full transition-all duration-300 cursor-pointer">
                <i className="ri-facebook-line text-white"></i>
              </a>
            </div>
          </div>

          <div>
            <h5 className="text-white font-bold mb-4 whitespace-nowrap">クイックリンク</h5>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('about')} className="text-white/60 hover:text-[#ff1493] transition-colors cursor-pointer whitespace-nowrap">
                  番組について
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('programs')} className="text-white/60 hover:text-[#ff1493] transition-colors cursor-pointer whitespace-nowrap">
                  放送中の番組
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('listen')} className="text-white/60 hover:text-[#ff1493] transition-colors cursor-pointer whitespace-nowrap">
                  聴き方
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('social')} className="text-white/60 hover:text-[#ff1493] transition-colors cursor-pointer whitespace-nowrap">
                  SNS
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-white/60 hover:text-[#ff1493] transition-colors cursor-pointer whitespace-nowrap">
                  お問い合わせ
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h5 className="text-white font-bold mb-4 whitespace-nowrap">放送情報</h5>
            <ul className="space-y-3 text-white/60">
              <li className="flex items-start gap-2">
                <i className="ri-calendar-line text-[#ff1493] mt-1"></i>
                <span>毎週火曜 18:30〜</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-radio-2-line text-[#ffd700] mt-1"></i>
                <span>コミュニティFM<br />83.6MHz</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-headphone-line text-white/60 mt-1"></i>
                <span>各種ポッドキャスト<br />配信中</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-white/40 text-sm">
              &copy; {currentYear} Windie's Mania SHABADABA. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-white/40 hover:text-[#ff1493] text-sm transition-colors cursor-pointer whitespace-nowrap"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
